<div style="padding: 2em">
	<p style="margin-bottom: 2em">
		The logged-in user does not have access to the Studio; please log out and
		log in using a different user
	</p>
	<button (click)="logout()">Log out</button>
</div>
